import { CartUpdatedEvent } from '@theme/events';
import { GIFT_ID, giftState } from './lsf-mystery-state.js';
const root = window.Shopify?.routes?.root || '/';
let pending = null;
let actionPending = null;
const sizeKeys = ['Cadeau pour', 'Taille haut', 'Taille bas', 'Pointure chaussettes'];
async function api(path, body) {
  const r = await fetch(root + path, body ? {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)} : {headers:{Accept:'application/json'},cache:'no-store'});
  const data = await r.json();
  if (!r.ok || data.status >= 400) throw new Error(data.description || 'Le panier ne peut pas être mis à jour. Réessaie.');
  return data;
}
function sectionOptions() {
  const ids = [...document.querySelectorAll('cart-drawer, cart-component')].map(el => el.dataset.sectionId || el.closest('[id^="shopify-section-"]')?.id.replace('shopify-section-','')).filter(Boolean);
  return {sections:[...new Set(ids)].slice(0,5),sections_url:location.pathname};
}
function refresh(cart) {
  if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
  if (!cart.sections || !Object.values(cart.sections).some(Boolean)) { location.reload(); return; }
  document.dispatchEvent(new CartUpdatedEvent(cart,{itemCount:cart.item_count,source:'lsf-mystery',sections:cart.sections}));
}
async function reconcile() {
  let cart = await api('cart.js');
  let changed = false;
  // A quantity split by Shopify can change line keys after each update.
  for (let pass=0; pass<3; pass++) {
    const {updates} = giftState(cart);
    if (!Object.keys(updates).length) break;
    cart = await api('cart/update.js',{updates,...sectionOptions()}); changed = true;
  }
  if (Object.keys(giftState(cart).updates).length) throw new Error('Vérifie le cadeau dans ton panier avant de continuer.');
  if (changed) refresh(cart);
  return cart;
}
function sync() {
  if (!pending) pending = reconcile().finally(() => {pending=null;});
  return pending;
}
function showError(message) {
  document.querySelectorAll('lsf-mystery-gift [role="status"]').forEach(el => {el.textContent=message;});
}
document.addEventListener('cart:updated', e => { if (e.detail?.data?.source !== 'lsf-mystery' && e.detail?.source !== 'lsf-mystery') sync().catch(e=>showError(e.message)); });
function readSizes(container) {
  const fields = [...container.querySelectorAll('[data-size-key]')];
  for (const field of fields) {
    if (!field.value) {
      const wasRequired = field.required;
      field.required = true;
      field.reportValidity();
      field.required = wasRequired;
      return null;
    }
  }
  return fields.length === sizeKeys.length ? Object.fromEntries(fields.map(field => [field.dataset.sizeKey, field.value])) : null;
}
class LSFMysteryGift extends HTMLElement {
  connectedCallback() {
    this.onclick = async e => {
      const b = e.target.closest('[data-add-mystery], [data-save-mystery]');
      if (!b || b.disabled || actionPending) return;
      const editor = b.closest('[data-gift-line]');
      const properties = readSizes(editor || this);
      if (!properties) return;
      b.disabled = true; this.setAttribute('aria-busy', 'true');
      actionPending = (async () => {
        const before = await sync();
        if (editor) {
          const line = before.items.find(item => item.key === editor.dataset.giftLine && String(item.variant_id) === GIFT_ID);
          if (!line) throw new Error(this.dataset.sizesRequired);
          const cart = await api('cart/change.js', {id: line.key, quantity: line.quantity, properties: {...line.properties, ...properties}, ...sectionOptions()});
          refresh(cart);
          return;
        }
        if (!giftState(before).canAdd) throw new Error('Ajoute au moins 50 € d’articles éligibles. Un seul cadeau offert par commande.');
        await api('cart/add.js', {items: [{id: GIFT_ID, quantity: 1, properties: {...properties, _lsf_mystery_offer: '50'}}]});
        const checked = await reconcile();
        if (!checked.items.some(i => String(i.variant_id) === GIFT_ID && i.final_line_price === 0)) throw new Error('Cette offre ne se cumule pas avec la réduction actuelle. Le cadeau payant a été retiré.');
        const cart = await api('cart/update.js', {updates: {}, ...sectionOptions()});
        refresh(cart);
      })();
      try { await actionPending; }
      catch (error) { showError(error.message); }
      finally { actionPending = null; b.disabled = false; this.removeAttribute('aria-busy'); }
    };
    sync().catch(e => showError(e.message));
  }
}
if (!customElements.get('lsf-mystery-gift')) customElements.define('lsf-mystery-gift',LSFMysteryGift);
// Recheck immediately before checkout, including a rapid click after changing quantity.
let checkoutPass=false;
document.addEventListener('click',async e=>{
  const target=e.target.closest('[name="checkout"],a[href*="/checkout"]');
  if (!target || checkoutPass) return;
  e.preventDefault();e.stopImmediatePropagation();
  try {
    if (actionPending) await actionPending;
    if (pending) await pending;
    const cart = await sync();
    const incomplete = cart.items.find(item => String(item.variant_id) === GIFT_ID && sizeKeys.some(key => !item.properties?.[key]));
    if (incomplete) {
      const editors = [...document.querySelectorAll('[data-gift-line]')];
      const editor = editors.find(el => el.dataset.giftLine === incomplete.key && el.getClientRects().length);
      if (editor) {
        editor.open = true;
        editor.scrollIntoView({block: 'center', behavior: 'smooth'});
        readSizes(editor);
      }
      const message = document.querySelector('lsf-mystery-gift')?.dataset.sizesRequired;
      if (!message) { location.href = root + 'cart'; return; }
      throw new Error(message);
    }
    checkoutPass = true; target.click();
  }
  catch(error){showError(error.message);} finally{checkoutPass=false;}
},true);
